export const formatAmount = (
  currency: string,
  lang: GenericTypes.Language,
  value: number,
): string =>
  new Intl.NumberFormat(lang, {
    style: 'currency',
    currency: currency || 'NOK',
  }).format(value);
